const poolData = {
  UserPoolId: 'us-east-1_x2OYsF6g5',
  ClientId: '123',
  endpoint: 'https://dev.dproz.com/auth',
};

export default poolData;